const defaultState = {
  isLoaded: false,
  rooms: [],
  room_students: [],
  students: []
}

const classroom = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_CLASSROOM_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };
    case 'SET_CLASSROOM_ADD':
      return {
        ...state,
        isLoaded: true,
        rooms: [...state.rooms, action.data],
      };
    case 'SET_CLASSROOM_STUDENT_ADD':
      return {
        ...state,
        isLoaded: true,
        students: [...state.students, action.data],
      };
    case 'SET_CLASSROOM_UP':
      return {
        ...state,
        isLoaded: true,
        rooms: state.rooms.map(_i => _i.id == action.data.id ? action.data : {..._i}),
      };
    case 'SET_CLASSROOM_DELETE':
      return {
        ...state,
        isLoaded: true,
        rooms: state.rooms.filter(_i => _i.id != action.data),
        selectRoom: null,
        room_students: [],
      };
    case 'SET_CLASSROOM_STUDENT_DELETE':
      return {
        ...state,
        isLoaded: true,
        students: state.students.filter(_i => _i.id != action.data),
      };
    default:
      return state
  }
}

export default classroom;
